export default "__VITE_ASSET__Wsh4DUZ2__"